import { AiFillPlusCircle } from "react-icons/ai";
import { FaAngleRight } from "react-icons/fa";

function OutlinedButton({ props }) {
  return (
    <div
      onClick={props.onClick}
      className={props.className}
      style={props.style}
    >
      <div className="d-flex align-items-center ms-3">
        {props.prefix && <div>{props.icon}</div>}
        <button>{props.label}</button>
      </div>
      {props.postfix && <div>{props.icon}</div>}
    </div>
  );
}
export default OutlinedButton;
